import {CanActivate, Router, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ConfigService} from '../../core/services/config.service';
import {AdditionalBookingConfirmComponent} from './additional-booking-confirm/additional-booking-confirm.component';

/**
 * Schützt die Zubucherseite und alle ihre Unterseiten (additional-booking,
 * additional-booking/:orderId, additional-booking/ordered/:orderId).
 *
 * Die Funktionalität gilt genau dann als eingeschaltet, wenn der Kombi-Werbeschlüssel in
 * 'subscription.printToKombiPrintEpaperCampaignId' konfiguriert ist. Ohne ihn kann pca weder
 * qualifizierte Abos ermitteln noch ein Kombi-Abo anlegen - die Seite wäre also funktionslos.
 * Ein zweiter An-/Aus-Schalter wäre eine zweite Wahrheit über denselben Zustand.
 *
 * Ist der Werbeschlüssel nicht gesetzt, wird die 404-Seite ausgeliefert: die Funktion soll nicht
 * als "vorhanden, aber gesperrt" erkennbar sein.
 *
 * Hinweis: CanActivate läuft VOR dem ConfigResolverService, daher wird die Vorgabe hier
 * via loadConfig() selbst (asynchron, gecacht) geladen statt über das synchrone getConfig().
 */
@Injectable({providedIn: 'root'})
export class AdditionalBookingGuard implements CanActivate {

  /**
   * Ziel bei abgeschalteter Funktion. Der Pfad passt auf keine Route und läuft damit in die
   * Wildcard '**' der NotFoundComponent.
   */
  private static readonly NOT_FOUND_PATH = '/not-found';

  constructor(private configService: ConfigService, private router: Router) {
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.configService.loadConfig(AdditionalBookingConfirmComponent.CAMPAIGN_CONFIG_KEY).pipe(
      map(config => {
        if (config?.value?.trim()) {
          return true;
        }
        return this.router.createUrlTree([AdditionalBookingGuard.NOT_FOUND_PATH]);
      }));
  }
}
